import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { memo } from 'react';

function VerificationPending({ close }: BottomSheetExtendedProps) {
  return (
    <Box alignItems="center" gap="space-600">
      <Image name="common.Documents" height={80} aspectRatio={1} />
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        locNS="shop"
        locKey="verificationPendingTitle"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="shop"
        locKey="verificationPendingDescription"
      />
      <Button
        width="100%"
        variant="primary"
        locNS="shop"
        locKey="verificationPendingCta"
        onPress={close}
      />
    </Box>
  );
}

export default memo(VerificationPending);
